import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { reformatTinyMCEiframe } from 'helpers/utilities';
FacilitatorTemplateInfo.propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    onTemplateClick: PropTypes.func,
    selectedTemplateID: PropTypes.string,
    isClickable: PropTypes.bool
};
export default function FacilitatorTemplateInfo(_a) {
    var _b = _a.id, id = _b === void 0 ? '' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.description, description = _d === void 0 ? '' : _d, _e = _a.thumbnail, thumbnail = _e === void 0 ? '' : _e, _f = _a.onTemplateClick, onTemplateClick = _f === void 0 ? null : _f, _g = _a.selectedTemplateID, selectedTemplateID = _g === void 0 ? '' : _g, _h = _a.isClickable, isClickable = _h === void 0 ? false : _h;
    useEffect(function () {
        reformatTinyMCEiframe('iframe');
    }, []);
    return (React.createElement("div", { className: clsx([
            'cardview__item cardview__item--boxed',
            isClickable && 'cardview__item--clickable',
            selectedTemplateID === id && 'cardview__item--selected'
        ]), style: { height: 'auto' }, onClick: function () { return onTemplateClick(id); } },
        React.createElement("div", { className: "cardview__inner" },
            React.createElement("div", { className: "cardview__avatar" },
                React.createElement("div", { className: "cardview__inneravatar", style: { backgroundImage: "url(".concat(thumbnail, ")") } })),
            React.createElement("div", { className: "cardview__content" },
                React.createElement("div", { className: "cardview__topcontent" }),
                React.createElement("div", { className: "cardview__title" }, name),
                React.createElement("div", { className: "cardview__desc", dangerouslySetInnerHTML: { __html: description } })))));
}
